// Lastslate editor entry. The renderer's classic-script `app.js`
// can't `import` ES modules directly; this file is the bundle entry
// that esbuild compiles into an IIFE attached to `window.LastslateEditor`.
//
// Public surface that app.js calls:
//   window.LastslateEditor.mountEditor({ root, initialDoc, onDocChanged })
//   window.LastslateEditor.fountainToDoc(parsedScript)
//   window.LastslateEditor.docToFountain(doc)
//   window.LastslateEditor.schema
//
// Build step: scripts/build-editor.js invokes esbuild with format=iife,
// globalName=LastslateEditor, outfile=src/renderer/generated/editor.bundle.js.
// index.html loads the bundle BEFORE app.js so the global is ready.

export { mountEditor, buildTestDoc, Y_FRAGMENT_NAME } from './mount.js';
export { fountainToDoc, docToFountain } from './fountain-bridge.js';
export { schema } from './schema.js';
export { ELEMENT_QUICK_ASSIGN } from './commands.js';

// Cmd-hold cheatsheet — app-wide UI, not editor-specific, but bundled
// here because app.js is a classic script and this bundle is the
// renderer's only ESM ingestion point.
export { initCmdCheatsheet } from './cmd-cheatsheet.js';

// Yjs helpers exposed for the LocalAdapter in the renderer. We only
// re-export the surface the adapter needs (encode / apply / create-doc)
// so the global API stays tight — full Yjs is still tree-shaken into
// the bundle for ProseMirror's own use.
import * as Y from 'yjs';
export const Yjs = {
  Doc: Y.Doc,
  XmlFragment: Y.XmlFragment,
  encodeStateAsUpdate: Y.encodeStateAsUpdate,
  applyUpdate: Y.applyUpdate,
};

// Hybrid offline-sync data layer. One Y.Doc per draft, y-indexeddb as
// canonical local store, @hocuspocus/provider as the optional network
// layer. See cloud-sync/doc-store.js for the rules.
import * as cloudSyncMod from './cloud-sync/doc-store.js';
export const cloudSync = cloudSyncMod;

// Live-rendering markdown editor for the scratchpad. Independent of
// the screenplay editor — separate schema, mounted in the right
// inspector pane. See notes-md/index.js for the rules.
export { mountNotesEditor } from './notes-md/index.js';
